module.exports = __webpack_public_path__ + "static/media/image_shopping_cart.48088727.svg";